<script>
    import R, {LOADER} from "../lib/requests";
    import {formatDate, copyObjectProperties, sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import Pagination from "../components/Pagination.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import MembershipGiftEdit from "./MembershipGiftEdit.svelte";
    import BatchGiftsModal from "./BatchGiftsModal.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";

    const pageHeaderControls = [
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ'},
        {id: 'batch-create', name: 'ΕΙΣΑΓΩΓΗ'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'date', title: 'ΗΜΕΡΟΜΗΝΙΑ', sortable: true, sort_way: 'DESC'},
        {key: 'card_number', title: 'ΑΡ. ΚΑΡΤΑΣ', sortable: true, class: 'hidden-xs'},
        {key: 'gift_el', title: 'ΔΩΡΟ', sortable: true, class: 'hidden-xs'},
        {key: 'viewed_at', title: 'ΕΜΦΑΝΙΣΗ', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
    ];

    const itemsPerPage = [20, 50, 100, 500];

    let list = null;
    let membershipGift = null;
    let selectedId = null;
    let showBatchCreate = false;

    let page = 1;
    let search = {
        date_from: null,
        date_to: null,
        card_number: null,
        offset: 0,
        limit: 20,
        sort_field: null,
        sort_way: null,
    };
    let totalGifts = 0;

    const onBatchCreate = () => {
        showBatchCreate = true;
    }

    const closeBatchCreate = param => {
        showBatchCreate = false;
    }

    const onCreate = () => {
        membershipGift = {};
    }

    const onEdit = obj => {
        selectedId = obj.id;
        membershipGift = obj;
    }

    const closeEdit = param => {
        if (param) {
            let item = list.find(x => x.id == param.id);
            if (!item) {
                list = [param, ...list];
                selectedId = param.id;
            } else {
                item.card_number = param.card_number;
                item.date = param.date;
                item.gift_el = param.gift_el;
                item.gift_en = param.gift_en;
                list = list;
            }
        }
        membershipGift = null;
    }

    const onDelete = (obj) => {
        Alert.delete("Διαγραφή δώρου", `Να διαγραφεί μόνιμα το δώρο της κάρτας μέλους "${obj.card_number}";`, () => deleteGift(obj.id));
    }

    const deleteGift = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != result);
            totalGifts--;
            Notifier.showMessage("Το δώρο διαγράφτηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.membershipGift.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const onClearSearch = () => {
        search.date_from = null;
        search.date_to = null;
        search.card_number = null;
        onSearch();
    }

    const load = () => {
        const onSuccess = result => {
            list = result.list;
            totalGifts = result.total;
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.membershipGift.index, search, onSuccess, onFailure, LOADER.PAGE);
    }

    load();
</script>

<PageHeader title="Δώρα Μελών" controls={ pageHeaderControls } on:create={ onCreate } on:batch-create={ onBatchCreate }
            on:reload={ load }/>

<div class="panel panel-simple p-2 mb-5">
    <div class="row">
        <div class="col-xl-2 col-lg-2 col-md-3 col-6">
            <div class="form-group-sm form-group-md ">
                <div class="form-item">
                    <div class="form-item-info top">από</div>
                    <input type="date" class="form-control" bind:value="{ search.date_from }"
                           on:change={ onSearch }>
                </div>
            </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-3 col-6">
            <div class="form-group-sm form-group-md ">
                <div class="form-item">
                    <div class="form-item-info top">έως</div>
                    <input type="date" class="form-control" bind:value="{ search.date_to }"
                           on:change={ onSearch }>
                </div>
            </div>
        </div>
        <div class="col-xl-6 col-lg-4 col-md-6">
            <div class="form-group-sm form-group-md ">
                <input type="text" class="form-control" bind:value="{ search.card_number }" placeholder="αρ. κάρτας"
                       on:change={ onSearch }>
            </div>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-3 col-6">
            <button class="btn btn-default btn-block text-truncate" on:click={ onClearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-3 col-6">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>ΕΥΡΕΣΗ</button>
        </div>
    </div>
</div>

<div class="mb-4">
    <div class="row">
        <div class="col-xl-2 col-md-4">
            <select class="form-select form-select-sm" bind:value="{ search.limit }" on:change="{ onSearch }">
                {#each itemsPerPage as item}
                    <option value="{ item }">εμφάνιση { item } / σελίδα</option>
                {/each}
            </select>
        </div>
        {#if totalGifts > 0}
            <div class="col-xl-8 col-md-8">
                <div class="mt-1">
                    Εγγραφές: { totalGifts }
                </div>
            </div>
        {/if}
    </div>
    <!--        <Checkbox label="Display code" bind:checked={ displayCode }/>-->
</div>

{#if list}
    {#if list.length}
        <table class="table table-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each list as item}
                <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                    <td class="date-column text-gray">
                        { formatDate(item.date, 'd-m-y') }
                    </td>
                    <td>
                        <span class="is-link" on:click="{ () => onEdit(item) }">
                            { item.card_number }
                        </span>
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.gift_el }
                    </td>
                    <td class="text-gray date-column hidden-xs">
                        { formatDate(item.viewed_at, 'd-m-y') }
                    </td>
                    <td class="button-column">
                        <button class="button" title="διαγραφή" on:click={ () => onDelete(item) }>
                            <AppIcon icon="trash" size="16"/>
                        </button>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ search.limit }" totalItems="{ totalGifts }"
                    page="{ page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel panel-simple panel-pad">
            Δεν βρέθηκαν εγγραφές!
        </div>
    {/if}
{/if}

{#if membershipGift}
    <MembershipGiftEdit {membershipGift} closeCallback="{ closeEdit }"/>
{/if}

{#if showBatchCreate}
    <BatchGiftsModal closeCallback="{ closeBatchCreate }"/>
{/if}